import InlineFormset from './InlineFormset';


export default InlineFormset;
